import { useEffect, useState } from "react";
import { ProgramMembership } from "../../API";
import { QueryStatus } from "../../app/types";
import { fetchProgramMembership, fetchProgramMembershipByUserAndProgram } from "./programMembershipsAPI";

export const useProgramMembership = (args: {
  programMembershipId?: string,
  programId?: string,
  userId?: string
}) => {
  const {programMembershipId, programId, userId} = args;

  const [programMembership, setProgramMembership] =
    useState<ProgramMembership | null>(null);
  const [status, setStatus] = useState<QueryStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const getProgramMembership = async (args: {
    programMembershipId?: string,
    programId?: string,
    userId?: string
  }): Promise<ProgramMembership | null> => {
    const {programMembershipId, programId, userId} = args;

    setStatus("loading");
    setError(null);

    try {
      let results;
      if (programMembershipId) {
        results = await fetchProgramMembership(programMembershipId);
      } else if (programId && userId) {
        results = await fetchProgramMembershipByUserAndProgram(userId, programId);
      } else {
        throw "incorrect params";
      }
      setProgramMembership(results);
      setStatus("succeeded");
      return results;
    } catch (error) {
      setStatus("failed");
      const stringifiedError = JSON.stringify(error);
      console.error(`error loading program membership:`, stringifiedError);
      setError(`Error loading program membership: ${stringifiedError}`);
    }
    return null;
  };

  useEffect(() => {
    if (programMembershipId || (userId && programId)) {
      getProgramMembership({programMembershipId, userId, programId});
    }
  }, []);

  return {
    programMembership,
    status,
    error,
    getProgramMembership
  };
};